import { useCallback, useMemo } from 'react';

import { useAuth } from '@/hooks/useAuth';
import { createSupabaseClient } from '@/integrations/supabase/client';

interface FetchProductProps {
  toolId: string;
}

export const useFetchProductByLinkedTool = () => {
  const { getToken } = useAuth();

  const supabase = useMemo(() => createSupabaseClient(getToken), [getToken]);

  const fetchProduct = useCallback(
    async ({ toolId }: FetchProductProps) => {
      if (!toolId) {
        return;
      }

      try {
        const { data } = await supabase
          .from('tool_versions')
          .select(
            'id, version_name, product_tool_links(id, tool_name, products(id, name))'
          )
          .eq('id', toolId)
          .single();

        if (!data) {
          return;
        }

        return {
          id: data.id,
          name: data.version_name,
          productName: data.product_tool_links?.products?.name ?? undefined,
          productId: data.product_tool_links?.products?.id ?? undefined,
        };
      } catch (error) {
        console.error('Error fetching product by linked tool:', error);
      }
    },
    [supabase]
  );

  return useMemo(() => ({ fetchProduct }), [fetchProduct]);
};
